export const keyboardCodes = {
  COMMA: 188,
  ENTER: 13,
  TAB: 9
};

export default { keyboardCodes };
